import Layout from '@layout/Index'

export default [
  {
    path: '/statistic',
    component: Layout,
    meta: {
      title: '数据统计',
      icon: 'el-icon-data-line',
      hidden: false,
      alwaysShow: true
    },
    children: [
      {
        path: '',
        redirect: 'city-group-config',
        hidden: true
      },
      // 城市分组
      {
        path: 'city-group-config',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/CityGroup/index.vue'),
        name: 'CityGroupConfig',
        meta: {
          title: '城市分组配置',
          icon: 'el-icon-menu',
          noCache: false,
          hidden: false,
          breadcrumb: false
        }
      },
      {
        path: 'city-group-config/detail',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/CityGroup/detail.vue'),
        name: 'CityGroupDetail',
        meta: {
          title: '城市分组详情',
          noCache: true,
          hidden: true,
          activeMenu: '/statistic/city-group-config'
        }
      },
      // 推广人员配置
      {
        path: 'promoter',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/Promoter/index.vue'),
        name: 'Promoter',
        meta: {
          title: '推广人员配置',
          icon: 'el-icon-user',
          noCache: false,
          hidden: false
        }
      },
      {
        path: 'promoter/detail',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/Promoter/detail.vue'),
        name: 'PromoterDetail',
        meta: {
          title: '推广人员详情',
          noCache: true,
          hidden: true,
          activeMenu: '/statistic/promoter'
        }
      },
      // 大屏项目配置
      {
        path: 'screen-project',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/ScreenProject/index.vue'),
        name: 'ScreenProject',
        meta: {
          title: '大屏项目配置',
          icon: 'el-icon-monitor',
          noCache: false,
          hidden: false
        }
      },
      {
        path: 'screen-project/detail',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/ScreenProject/detail.vue'),
        name: 'ScreenProjectDetail',
        meta: {
          title: '大屏项目详情',
          noCache: true,
          hidden: true,
          activeMenu: '/statistic/screen-project'
        }
      },
      {
        path: 'screen-project/display-settings',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/ScreenProject/displaySettings.vue'),
        name: 'ScreenProjectDisplaySettings',
        meta: {
          title: '大屏项目展示设置',
          noCache: true,
          hidden: true,
          activeMenu: '/statistic/screen-project'
        }
      },
      {
        path: 'screen-project/audit-screen-config',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/ScreenProject/auditScreenConfig.vue'),
        name: 'AuditScreenConfig',
        meta: {
          title: '审单大屏配置',
          noCache: true,
          hidden: true,
          activeMenu: '/statistic/screen-project'
        }
      },
      // 批量任务
      {
        path: 'screen-project/batch-jobs',
        component: () => import(/* webpackChunkName: "statistic" */ './pages/ScreenProject/BatchJobsTable.vue'),
        name: '统计管理批量任务',
        meta: {
          title: '批量任务',
          icon: 'el-icon-upload',
          noCache: false,
          hidden: false
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/statistic/statistic.route.js